import { useEffect } from "react";
import { scrollToTop } from "./utils";

function useScrollToTopOnMount() {
  useEffect(() => {
    scrollToTop();
  }, []);
}

export { useScrollToTopOnMount };